<template>
  <div id="app">
    <router-view></router-view>
    <Footer />
    <Resize v-show="resizeFlag" />
  </div>
</template>

<script>
import Footer from "./components/footer";
import { value, onMounted } from "vue-function-api";
import session from "./utils/session";
import Resize from "./components/resize.vue";
import { LOCALE_KEY } from "./utils/constants"
import { setUp, getMostFitLocale } from "./locales/index";
export default {
  name: "app",
  components: {
    Footer,
    Resize
  },
  setup(props, context) {
    const {
      root: { $route, $i18n }
    } = context;
    const resizeFlag = value(false);
    const getLang = () => {
      let language = (
        navigator.language || navigator.browserLanguage
      ).toLowerCase();
      return window.localStorage.getItem(LOCALE_KEY) || language
    };
    const resizeFontSize = () => {
      const docEl = document.documentElement;
      const { clientWidth } = docEl;
      if (!clientWidth) return;
      const fs = 75 * (clientWidth / 750);
      docEl.style.fontSize = `${fs}px`;
    };
    const handleResize = () => {
      let supportOrientation =
        typeof window.orientation === "number" &&
        typeof window.onorientationchange === "object";
      if (supportOrientation) {
        switch (window.orientation) {
          case 90:
          case -90:
            resizeFlag.value = true;
            break;
          default:
            resizeFlag.value = false;
            break;
        }
      } else {
        resizeFlag.value =
          window.innerWidth > window.innerHeight ? true : false;
      }
    };
    onMounted(() => {
      resizeFontSize();
      window.addEventListener("resize", resizeFontSize, false);
      const lang_to_set = getMostFitLocale(getLang());
      setUp(lang_to_set)
      $i18n.locale = lang_to_set
      $route.query.token?session.setString("token", $route.query.token):"";
      let supportOrientation =
        typeof window.orientation === "number" &&
        typeof window.onorientationchange === "object";
      handleResize();
      //监听横屏
      if (supportOrientation) {
        window.addEventListener("orientationchange", handleResize);
      } else {
        //监听resize事件
        window.addEventListener("resize", handleResize);
      }
    });
    return {
      resizeFlag
    };
  }
};
</script>

<style lang="scss">
// body {
//   margin: 0;
//   padding: 0;
// }
// #app {
//   width: 100%;
// }
</style>
